import { Typography } from '@ag1/ui';
import { ImageAndTiles } from 'types/studio/studio';
import CustomPortableText from 'shared/studio/PortableText/PortableText';
import styles from './Heading.module.scss';

type Props = Pick<ImageAndTiles, 'headline' | 'subtitle'>;

const Heading = ({ headline, subtitle }: Props) => (
  <>
    <Typography variant="headlineSans" size="2" color="black-new" noPadding>
      <CustomPortableText value={headline} tag="h2" />
    </Typography>
    {subtitle && (
      <Typography
        variant="portalSubtitle"
        size="3"
        color="black-new"
        className={styles.subtitle}
        noPadding>
        <CustomPortableText value={subtitle} tag="h3" />
      </Typography>
    )}
  </>
);

export default Heading;
